import {
    BAROMETRIC_PRESSURE_LINE,
    BarometricPressureChart,
} from '@/components/spotter/historicalDataTab/BarometricPressureSection';
import { AlertTriggerReferenceChartProps } from '@/components/spotter/notificationTab/AlertReferenceChart';
import { useAlertsFromForm } from '@/components/spotter/notificationTab/useAlertsFromForm';
import { useSpotterContext } from '@/context/SpotterContext';

const LINES = [BAROMETRIC_PRESSURE_LINE];

export const BarometricPressureAlertReferenceChart = ({ enabled = false }: AlertTriggerReferenceChartProps) => {
    const { spotterId } = useSpotterContext();
    const alerts = useAlertsFromForm();

    if (!spotterId) {
        return;
    }

    return (
        <BarometricPressureChart
            chartTitle={'Barometric pressure alert'}
            spotterId={spotterId}
            queryEnabled={enabled}
            showAlertLines={true}
            scaleToFitAlerts={true}
            lines={LINES}
            alertLines={alerts}
        />
    );
};
